import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "header__h1" }, "Library", -1)
const _hoisted_3 = { class: "routers" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "LAIT DSM", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Komponenter", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Animationer", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LaitLogo = _resolveComponent("LaitLogo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_OverviewLayout = _resolveComponent("OverviewLayout")!
  const _component_ShowcaseView = _resolveComponent("ShowcaseView")!
  const _component_ShowcaseLayout = _resolveComponent("ShowcaseLayout")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["background-color", { 'background-color--teal': _ctx.getPaths }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", {
        class: _normalizeClass(["header", { 'header--overview': _ctx.getPaths }])
      }, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "header__logo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LaitLogo)
          ]),
          _: 1
        })
      ], 2),
      (_ctx.getPaths)
        ? (_openBlock(), _createBlock(_component_OverviewLayout, { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, {
                  class: "routers__link",
                  to: "/",
                  tabindex: "0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    (_ctx.getDSMCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getDSMCount), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "routers__link",
                  to: "/komponenter/",
                  tabindex: "0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    (_ctx.getComponentCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.getComponentCount), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "routers__link",
                  to: "/animations/",
                  tabindex: "0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    (_ctx.getAnimationCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.getAnimationCount), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component, route }) => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: route.path,
                    onDsmCount: _ctx.getDSM,
                    onComponentCount: _ctx.getComponent,
                    onAnimationCount: _ctx.getAnimation
                  }, null, 40, ["onDsmCount", "onComponentCount", "onAnimationCount"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ShowcaseLayout, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_ShowcaseView, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component, route }) => [
                        _createVNode(_Transition, {
                          name: route.meta.transition,
                          mode: 'out-in'
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                              key: route.path
                            }))
                          ]),
                          _: 2
                        }, 1032, ["name"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
    ])
  ], 2))
}